export const VISITOR_COOKIE = 'tp_visitor'

export function readCookie(request: Request, name: string) {
  const header = request.headers.get('Cookie')
  if (!header) return null

  for (const part of header.split(';')) {
    const [key, ...value] = part.trim().split('=')
    if (key === name) return decodeURIComponent(value.join('='))
  }

  return null
}

export function cookieHeader(name: string, value: string, maxAgeSeconds: number) {
  return [
    `${name}=${encodeURIComponent(value)}`,
    'Path=/',
    `Max-Age=${maxAgeSeconds}`,
    'SameSite=Lax',
    'Secure',
  ].join('; ')
}

export function getOrCreateCookieId(request: Request, name: string) {
  return readCookie(request, name) ?? crypto.randomUUID()
}
